import { AddressFormValue } from '@psl/flows/common/address/components/AddressDetailForm';
import {
  deferredValid,
  FormOptions,
  required,
} from '@psl/functions/ux/form/useForm';
import { emailValidator } from '@psl/functions/validators/emailValidator';
import { postalCodeValidator } from '@psl/functions/validators/postalCodeValidator';
import { textValidator } from '@psl/functions/validators/textValidator';
import { Address } from '@psl/models/ClientModels';
import {
  validateGenericPhone,
  validateUSPhone,
  validateUSState,
} from '@psl/utils/validation';

export const addressFormOptions = (
  defaultValues?: Partial<Address>,
): FormOptions<AddressFormValue> => ({
  firstName: {
    defaultValue: defaultValues?.firstName ?? '',
    valid: textValidator({ required: true, unicodeBMPOnly: true, trim: true }),
  },
  lastName: {
    defaultValue: defaultValues?.lastName ?? '',
    valid: textValidator({ required: true, unicodeBMPOnly: true, trim: true }),
  },
  primaryPhone: {
    defaultValue: defaultValues?.primaryPhone ?? '',
    valid: deferredValid(({ country }) =>
      country === 'US' ? validateUSPhone : validateGenericPhone,
    ),
  },
  email: {
    defaultValue: defaultValues?.email ?? '',
    valid: emailValidator({ required: true, trim: true }),
  },
  line1: {
    defaultValue: defaultValues?.line1 ?? '',
    valid: textValidator({ required: true, unicodeBMPOnly: true, trim: true }),
  },
  line2: {
    defaultValue: defaultValues?.line2 ?? '',
    valid: textValidator({ required: false, unicodeBMPOnly: true, trim: true }),
  },
  city: {
    defaultValue: defaultValues?.city ?? '',
    valid: textValidator({ required: true, unicodeBMPOnly: true, trim: true }),
  },
  state: {
    defaultValue: defaultValues?.state ?? '',
    valid: deferredValid(({ country }) =>
      country === 'US' ? validateUSState : required,
    ),
  },
  postalCode: {
    defaultValue: defaultValues?.postalCode ?? '',
    valid: postalCodeValidator({ required: true, trim: true }),
  },
  country: { defaultValue: defaultValues?.country ?? 'US' },
});
